export default "__VITE_ASSET__ChAkDGnF__"